import { AxiosInstance } from 'axios'
import { IOrganisation } from '../../types/Organisation'

export default (axios: AxiosInstance) => {
  return {
    update(organisation: IOrganisation) {
      return axios
        .post('/organisation/update', organisation)
        .then((res) => res.data)
    }
  }
}
